import * as e from "react";
import { forwardRef as o } from "react";
const i = o(function(t, r) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: r,
      viewBox: "0 0 24 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("path", { d: "M19.5703 20H0L3.42965 0H23L19.5703 20Z", fill: "#D70A0A" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M15.8 7.06667L13.2334 4.5M15.8 7.06667L13.2334 9.63333M15.8 7.06667H7.00015",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.46665
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M7.00007 12.9333L9.56669 15.5M7.00007 12.9333L9.56669 10.3667M7.00007 12.9333L15.7999 12.9333",
        stroke: "#fff",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.46665
      }
    )
  );
});
export {
  i as StarSubIcon
};
